import React, { useState } from 'react';
import { documentTabKeys, formModes } from '../../constants.js';
import i18next from "../../i18n.js";

const DocumentTabs = (props) => {
    const [activeTabKey, setActiveTabKey] = useState(documentTabKeys.general);

    const onItemClick = (key) => {
        setActiveTabKey(key);
        if (props.onItemClick) {
            props.onItemClick(key);
        }
    }

    return <div className='document-tabs'>
        <div className='document-tab-items'>
            <div
                className={'tab ' + documentTabKeys.general + (activeTabKey === documentTabKeys.general ? ' active' : '')}
                key={documentTabKeys.general}
                onClick={() => onItemClick(documentTabKeys.general)}>
                {i18next.t(`document.tabs.${documentTabKeys.general}`)}
            </div>
            {props.formMode != formModes.create && <div
                className={'tab ' + documentTabKeys.comments + (activeTabKey === documentTabKeys.comments ? ' active' : '')}
                key={documentTabKeys.comments}
                onClick={() => onItemClick(documentTabKeys.comments)}>
                {i18next.t(`document.tabs.${documentTabKeys.comments}`) + (props.commentsCount > 0 ? ` (${props.commentsCount})` : '')}
            </div>}
        </div>
    </div>
}
export default DocumentTabs;